export default __webpack_public_path__ + "static/media/hm-sp-img.bdc88e89.webp";